/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import CircularProgress from '@mui/material/CircularProgress';
import Paper from '@mui/material/Paper';
import Title from '@mui/material/Typography';
import { useCallback, useMemo, useState } from 'react';

import ContainerUserPaymentForm from 'components/UserPaymentForm';
import { styles } from 'routes/renewMember/styles/renewMemberNewCard.styles';
import { prepareRenewInitialValues, prepareRenewMemberTypes } from 'adapters';
import { RENEW_NEW_CARD_INIT_VALUES } from 'constants/initial-values';
import useProcessPayment from 'hooks/useProcessPayment';

const RenewMemberNewCard = ({ setPaymentStatus, renewInfo }) => {
	const [loading, setLoading] = useState(true);

	const initialValues = useMemo(() => {
		if (renewInfo.member?.vid) {
			return prepareRenewInitialValues({ member: renewInfo.member });
		}

		return RENEW_NEW_CARD_INIT_VALUES;
	}, [renewInfo.member]);

	const memberTypes = useMemo(() => {
		return prepareRenewMemberTypes({ memberTypes: renewInfo.user?.member_types });
	}, [renewInfo.user?.member_types]);

	const onPaymentComplete = useCallback(() => setLoading(false), []);

	const memoizedSetLoading = useCallback(state => {
		setLoading(state);
	}, []);

	const processPayment = useProcessPayment({ onPaymentComplete, renewInfo, setPaymentStatus });

	return (
		<Paper elevation={2} sx={styles.card}>
			{loading && (
				<Box sx={styles.centered}>
					<CircularProgress size={56} />
				</Box>
			)}
			<CardHeader
				disableTypography
				title={
					<Title component={'span'} variant="h6" color="primary">
						Renew Member with New Card
					</Title>
				}
			/>

			<CardContent>
				<ContainerUserPaymentForm
					isLoading={loading}
					onSubmitHandler={processPayment}
					memberTypes={memberTypes}
					setLoading={memoizedSetLoading}
					initialValues={initialValues}
					isRenewForm
				/>
			</CardContent>
		</Paper>
	);
};

export default RenewMemberNewCard;
